
import { defineComponent, reactive, toRefs, watch, onMounted } from "vue";
import katex from "katex";

export default defineComponent({
  name: "Formula",
  props: {
    formula: {
      type: String,
      required: true,
    },
    inline: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  setup(props) {
    const state: { container: HTMLElement | null } = reactive({
      container: null,
    });

    const renderFormula = () => {
      if (state.container != null) {
        katex.render(props.formula, state.container, {
          throwOnError: false,
        });
      }
    };

    watch(
      () => props.formula,
      () => {
        renderFormula();
      }
    );

    onMounted(() => {
      renderFormula();
    });

    return {
      ...toRefs(state),
    };
  },
});
